import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AutomationRuleCard } from "@/components/governance/AutomationRuleCard";

const rules = [
  {
    name: "Auto-create actions from meeting notes",
    description: "Extract action items from AI summaries and assign to committee owners.",
    status: "enabled" as const,
  },
  {
    name: "ToR renewal reminders",
    description: "Notify committee owners and approvers 30/15/7 days before review date.",
    status: "enabled" as const,
  },
  {
    name: "Escalate overdue approvals",
    description: "Escalate pending approvals to chairperson after SLA breach.",
    status: "disabled" as const,
  },
  {
    name: "Cross-module sync with Team Management",
    description: "Sync committee role changes with team profile role mappings.",
    status: "planned" as const,
  },
];

export default function TaskAutomation() {
  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="text-3xl font-medium text-foreground">Task Automation (PoC)</h1>
        <p className="text-muted-foreground">
          Static prototype showing governance automations that connect meetings, ToR, and assignments.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {rules.map((rule) => (
          <AutomationRuleCard key={rule.name} {...rule} />
        ))}
      </div>

      <Card className="shadow-card">
        <CardHeader>
          <CardTitle>Automation Workflow Preview</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-muted-foreground">
          <p>Meeting notes ingested to AI extracts actions to assign owner to notify assignees to track completion.</p>
          <p>ToR submitted to trigger approval reminders to reach approval threshold to mark ToR approved.</p>
          <p>Committee owner changed to sync role map with team management to update governance dashboards.</p>
        </CardContent>
      </Card>
    </div>
  );
}
